import React, { useEffect } from 'react';

const Privacy = () => {
  useEffect(() => {
    // Google Analytics事件跟踪
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', {
        page_title: 'Privacy Policy',
        page_location: '/privacy',
        custom_parameters: {
          legal_page: 'privacy',
          page_type: 'legal_document'
        }
      });
    }
  }, []);

  // Privacy页面强制使用英文内容
  const englishContent = {
    title: "Privacy Policy",
    intro: {
      title: "Our Privacy Commitment",
      content: "We are committed to protecting your privacy and being transparent about how we handle your information. This Privacy Policy explains our data practices for Online Notepad. Our core principle is data minimization - all document data remains stored locally in your browser and never leaves your device."
    },
    collection: {
      title: "Information Collection",
      content: "We do not collect, store, or transmit your document content. All text data is saved locally in your browser using HTML5 localStorage technology. We may collect anonymous usage statistics to improve our service, but this does not include any personal information or document content."
    },
    usage: {
      title: "How We Use Information",
      content: "Since your document data is stored locally, we cannot access or use this information. Any anonymous statistics we collect are used solely to improve user experience and service quality. We use this data to understand how features are used and to identify areas for improvement."
    },
    storage: {
      title: "Data Storage",
      content: "Your documents are saved using your browser's localStorage functionality on your device. This data is not transmitted to our servers. Data will remain in your browser until you clear your browser data or uninstall your browser. We recommend regularly backing up important documents to your computer."
    },
    sharing: {
      title: "Information Sharing",
      content: "We do not share, sell, or disclose your personal information or document content to third parties. Since data is stored locally, we actually cannot access your content. Your privacy is maintained through our technical architecture that keeps all data on your device."
    },
    security: {
      title: "Data Security",
      content: "Your data security primarily depends on your device and browser security. Since all processing happens locally in your browser, your documents are as secure as your device. We recommend keeping your browser and operating system updated, and regularly backing up important documents."
    },
    rights: {
      title: "Your Rights",
      content: "You have complete control over your data. You can delete data stored in your browser at any time, export your documents, or stop using our service. Your data always belongs to you, and our local-storage approach ensures you maintain full control."
    },
    changes: {
      title: "Policy Updates",
      content: "We may update this Privacy Policy from time to time. Any significant changes will be prominently displayed on our website. Continued use of the service indicates acceptance of the updated Privacy Policy."
    },
    contact: {
      title: "Contact Us",
      content: "If you have any questions or concerns about this Privacy Policy, please contact us through the contact information provided on our website. We are committed to addressing your privacy-related concerns."
    }
  };

  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>{englishContent.title}</h1>
        <div className="legal-content">
          <section>
            <h2>{englishContent.intro.title}</h2>
            <p>{englishContent.intro.content}</p>
          </section>
          
          <section>
            <h2>{englishContent.collection.title}</h2>
            <p>{englishContent.collection.content}</p>
          </section>
          
          <section>
            <h2>{englishContent.usage.title}</h2>
            <p>{englishContent.usage.content}</p>
          </section>
          
          <section>
            <h2>{englishContent.storage.title}</h2>
            <p>{englishContent.storage.content}</p>
          </section>
          
          <section>
            <h2>{englishContent.sharing.title}</h2>
            <p>{englishContent.sharing.content}</p>
          </section>
          
          <section>
            <h2>{englishContent.security.title}</h2>
            <p>{englishContent.security.content}</p>
          </section>
          
          <section>
            <h2>{englishContent.rights.title}</h2>
            <p>{englishContent.rights.content}</p>
          </section>
          
          <section>
            <h2>{englishContent.changes.title}</h2>
            <p>{englishContent.changes.content}</p>
          </section>
          
          <section>
            <h2>{englishContent.contact.title}</h2>
            <p>{englishContent.contact.content}</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Privacy;